import { SCHEMA_VERSIONS } from "../constants/schemaVersions";
import { assertArray, assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const createOrganization = ({
  id = createUuid(),
  slug,
  name,
  enabledModules = [],
  settings = {},
  createdAt = nowIso(),
  updatedAt = createdAt,
  schemaVersion = SCHEMA_VERSIONS.ORGANIZATION,
}) => {
  assertString(id, "organization.id");
  assertString(slug, "organization.slug");
  assertString(name, "organization.name");
  assertArray(enabledModules, "organization.enabledModules");

  return {
    id,
    slug,
    name,
    enabledModules,
    settings,
    createdAt,
    updatedAt,
    schemaVersion,
  };
};
